import React, { Fragment } from 'react'
import { StackNavigationProp } from '@react-navigation/stack'
import { useNavigation } from '@react-navigation/native'
import moment from 'moment'
import { useSelector } from 'react-redux'
import { ScrollView, View } from 'react-native'
import { useSafeAreaInsets } from 'react-native-safe-area-context'
import { Feature, useFeatureFlag } from '@src/components'
import { AppStackParamList } from '@src/navigation/types'
import { userSelector } from '@src/selectors/app'
import { StyleService, useStyleSheet } from '@src/style/service'
import { nextRecurringAppointmentSlotSelector } from '../../models/nutritionistHub.selectors'
import { EhrAppointmentCustomType } from '../../utils'
import { CallCard } from './CallCard'
import { RateCoach } from './RateCoach'

const VideoCallsList = ({
  appointments,
  upcoming,
}: {
  appointments: EhrAppointmentCustomType[]
  upcoming?: boolean
}) => {
  const navigation = useNavigation<StackNavigationProp<AppStackParamList>>()
  const isCoachRatingEnabled = useFeatureFlag(Feature.CoachRating)
  const styles = useStyleSheet(themedStyles)

  const insets = useSafeAreaInsets()

  const user = useSelector(userSelector)
  const nextRecurringAppointmentSlot = useSelector(nextRecurringAppointmentSlotSelector)

  const onAppointmentCardPress = (appointment: EhrAppointmentCustomType) => {
    const { id } = appointment

    navigation.navigate('VideoCallModal', { id })
  }

  return (
    <ScrollView
      style={[styles.container]}
      contentContainerStyle={{ paddingTop: 24, paddingBottom: insets.bottom + 24 }}
    >
      <View style={styles.callsContainer}>
        {appointments.map((appointment) => {
          const { id, title, meetingAt, lastState, providerName, kind, recurring } = appointment
          const inFuture = meetingAt && moment(meetingAt).isAfter(moment())

          return (
            <Fragment key={id}>
              <CallCard
                title={title}
                meetingAt={meetingAt}
                appointmentKind={kind}
                lastStateKind={lastState.kind}
                chargeKind={appointment.attendances[0].chargeKind}
                coachName={providerName}
                recurring={recurring}
                onPress={inFuture ? () => onAppointmentCardPress(appointment) : undefined}
              />

              {isCoachRatingEnabled &&
                user?.lastOccurredCoachingAppointment &&
                !user.lastOccurredCoachingAppointment.coachRating &&
                user.lastOccurredCoachingAppointment.id === id &&
                providerName && <RateCoach coachName={providerName} appointmentId={id} />}
            </Fragment>
          )
        })}
      </View>
      {upcoming && nextRecurringAppointmentSlot && (
        <View style={[styles.callsContainer, { marginTop: 24 }]}>
          <CallCard
            meetingAt={nextRecurringAppointmentSlot.meetingAt}
            coachName={nextRecurringAppointmentSlot.coachName}
            appointmentKind={nextRecurringAppointmentSlot.appointmentKind}
            recurring
            placeholder
          />
        </View>
      )}
    </ScrollView>
  )
}

export { VideoCallsList }

const themedStyles = StyleService.create({
  container: {
    backgroundColor: 'theme.background',
    flex: 1,
  },
  callsContainer: {
    paddingHorizontal: 16,
    rowGap: 24,
  },
})
